import { render, staticRenderFns } from "./solarSpace.vue?vue&type=template&id=f61de446"
import script from "./solarSpace.vue?vue&type=script&lang=js"
export * from "./solarSpace.vue?vue&type=script&lang=js"
import style0 from "./solarSpace.vue?vue&type=style&index=0&id=f61de446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports